import React from 'react';
import { RadioButton } from '@paypalcorp/pp-react-radio';
import { Badge } from '@paypalcorp/pp-react-badge';
import getLocaleMessages from '../utils/localesMessages';
import PropTypes from 'prop-types';
import { appendCdnHostName } from '../../utility/geoUtils';
import getStore from '../store/configureStore';
import { shouldShowBadge } from '../utilsV3/badgeUtils';

const {
  main: { label },
  fullPage,
  popUp,
} = getLocaleMessages('buttonsV3/fullPageVsPopup');

const FullPageVsPopup = ({ input: { value, onChange } }) => {
  const application = getStore()?.getState()?.application ?? {};
  const badgeContent = shouldShowBadge(
    application?.showNewFeatureBadge ?? false
  );

  const renderContent = (mainLabel, helperText, src) => {
    return (
      <div className="radio-btn-content">
        <img src={src} alt="" aria-hidden="true" className="radio-icon" />
        <span className="radio-btn-text">
          {mainLabel}
          <p className="helper-text">{helperText}</p>
        </span>
      </div>
    );
  };

  const jsxLabel = (
    <div className="label-badge-feature">
      <div>{label}</div>
      {badgeContent && (
        <Badge aria-hidden={true} type="feature" className="badge-feature">
          {badgeContent}
        </Badge>
      )}
    </div>
  );

  return (
    <RadioButton
      name="useFullPageExperience"
      className="full-vs-popup-container"
      radioLabelClassName="full-vs-popup-radio-wrapper"
      label={jsxLabel}
      value={value || 'yes'}
      onChange={(e) => onChange(e.target.value)}
      options={[
        {
          label: renderContent(
            fullPage.label,
            fullPage.helperText,
            appendCdnHostName(
              '/paypal-ui/illustrations/focused/svg/donate-full-page.svg'
            )
          ),
          value: 'yes',
        },
        {
          label: renderContent(
            popUp.label,
            popUp.helperText,
            appendCdnHostName(
              '/paypal-ui/illustrations/focused/svg/donate-pop-up.svg'
            )
          ),
          value: 'no',
          className: 'radio-btn-pop-up-v3',
        },
      ]}
    />
  );
};

FullPageVsPopup.propTypes = {
  input: PropTypes.object,
};

export default FullPageVsPopup;
